// ENV value productions or development is set in package.json.
// Udpate version in this file before deploymet tuo make sure that js and css files are reloaded.
// --dist-dir setting for parcel build and watch in package.json
module.exports = {
    version: Math.floor(Date.now() / 1000),
    environment: process.env.ENV,
    enableAnalytics: process.env.ENABLE_ANALYTICS === 'true',
    quickBuild: process.env.QUICK_BUILD === 'true',
    development: {
        client: "http://localhost:3000",
        server: "http://localhost:8080",
        console: "http://localhost:3000",
        rootPath: "",
        staticFilesRootPath: "",
        absoluteRootPath: "http://localhost:3000",
        recaptchaSiteKey: "6LcEGm4bAAAAAM6t63kP0D7C0lowDj1vr5eOyk8n"
    },
    production: {
        client: "",
        server: "https://api.youpret.com",
        console: "https://console.youpret.com",
        rootPath: "",
        staticFilesRootPath: "",
        absoluteRootPath: "https://www.youpret.com",
        recaptchaSiteKey: "6LdSfKYUAAAAALn4EJIUF6xju2sayl10bBbNSbwA"
    },
    browserSyncStartPath: "/fi/"
};